import { defineComponent as V, ref as s, onMounted as P, watch as S, h as U, openBlock as p, createBlock as f, unref as i, withCtx as h, createVNode as v, createElementVNode as _, resolveDynamicComponent as w, createCommentVNode as x } from "vue";
import D from "./ghl-ui.es308.js";
import $ from "./ghl-ui.es73.js";
import "./ghl-ui.es62.js";
import { countryDetails as m } from "./ghl-ui.es309.js";
import "./ghl-ui.es310.js";
import { parsePhoneNumberWithError as k } from "./ghl-ui.es311.js";
import y from "./ghl-ui.es145.js";
const B = { class: "button-container" }, C = V({
  name: "UIInputPhone",
  inheritAttrs: !1
}), E = V({
  ...C,
  props: {
    id: String,
    countryCode: String,
    disabled: Boolean,
    value: String
  },
  emits: [
    "internationalFormat",
    "isValid",
    "nationalFormat",
    "update:countryCode",
    "update:value"
  ],
  setup(c, { emit: b }) {
    const r = c, l = b, a = function() {
      return r.countryCode ? s(
        m.filter((e) => e.code === r.countryCode)[0]
      ) : s(m.filter((e) => e.code === "US")[0]);
    }();
    P(() => {
      d(r.value, a.value.code);
    }), S(
      () => r.value,
      (e) => {
        d(e, a.value.code);
      }
    );
    function F(e) {
      d(e, a.value.code);
    }
    function N(e) {
      const [t, o] = e.split("--");
      a.value = m.filter(
        (n) => n.code === t && n.name === o
      )[0], d(r.value, t);
    }
    function u({
      countryCode: e,
      internationalFormat: t,
      isPhoneNumberValid: o,
      nationalFormat: n,
      phoneNumber: g
    }) {
      l("update:countryCode", e), l("internationalFormat", t), l("isValid", o), l("nationalFormat", n), l("update:value", g);
    }
    function d(e, t) {
      try {
        const o = k(
          e,
          t
        ), n = o.isValid() && o.country === t;
        if (n)
          return u({
            countryCode: t,
            internationalFormat: o.formatInternational(),
            isPhoneNumberValid: n,
            nationalFormat: o.formatNational(),
            phoneNumber: o.formatNational()
          });
        u({
          countryCode: t,
          internationalFormat: "",
          isPhoneNumberValid: n,
          nationalFormat: "",
          phoneNumber: e
        });
      } catch {
        u({
          countryCode: t,
          internationalFormat: "",
          isPhoneNumberValid: !1,
          nationalFormat: "",
          phoneNumber: e
        });
      }
    }
    const I = m.map((e) => ({
      label: `${e.name} ${e.phoneCode}`,
      /**
       * To form unique value, code & name are combined because
       * the code 'BQ' is added for 2 countries, except the name everything is same.
       */
      value: `${e.code}--${e.name}`,
      icon: () => U(e.icon),
      placeholder: e.placeholder
    }));
    return (e, t) => (p(), f($, {
      modelValue: c.value,
      id: c.id,
      class: "phone-input-container",
      placeholder: i(a).placeholder,
      disabled: c.disabled,
      "onUpdate:modelValue": F
    }, {
      prefix: h(() => [
        v(i(y), {
          options: i(I),
          onOnSelect: N
        }, {
          trigger: h(() => [
            _("div", B, [
              i(a) ? (p(), f(w(i(a).icon), { key: 0 })) : x("", !0),
              v(i(D), { class: "w-5 h-5" })
            ])
          ]),
          _: 1
        }, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "id", "placeholder", "disabled"]));
  }
}), G = E;
export {
  G as default
};
